export const menuItems = {
  lead_icon: 'assets/img/menuIcon/lead_icon.svg',
  calendar_icon: 'assets/img/menuIcon/calendar_icon.svg',
  task_icon: 'assets/img/menuIcon/task_icon.svg',
  my_task_icon: 'assets/img/MyTasks.svg',
  clip_board_icon: 'assets/img/clipboard-list.svg',
  company_icon: 'assets/img/company.svg',
  my_lead_icon: 'assets/img/Lead.svg',
  office_setup_icon: 'assets/img/menuIcon/calendar_time.svg',
  member_ship_icon: 'assets/img/menuIcon/member_ship.svg',
  matrix_icon: 'assets/img/menuIcon/matrix.svg',
  menu_icon: 'assets/img/menuIcon/menu.svg',
  task_setup_icon: 'assets/img/menuIcon/Clipboard.svg',
  entity_manager_icon: 'assets/img/menuIcon/entity_manager.svg',
  help_icon: 'assets/img/menuIcon/help.svg',
  report_icon: 'assets/svg/report.svg',
  create_report_icon: 'assets/svg/create_report.svg',
  kpi_icon: 'assets/svg/kpi.svg',
  kpi_board: 'assets/svg/kpi_board.svg',
  check_one_icon: 'assets/img/check-one.svg',
  listing_report_icon: 'assets/img/dashboadIcon/listing.svg',
};
